export default function(error) {
  console.error(error);
  throw error;
};